@if (isLoading | async) {
  @if (!doNotShowLoadingSpinner()) {
    <div class="flex flex-wor space-x-2">
      <app-loading [classes]="['h-6', 'w-6']" [noWhitespace]="true" [hideText]="true"></app-loading>
    </div>
  }
} @else {
  <div class="flex flex-row items-center space-x-2 text-sm mr-2 text-gray-700">
    @if (stockSubject | async; as stock) {
      @if (stock.onlyOnOrder) {
        <ng-icon name="heroClock" size="20px" class="h-5 w-5 flex-shrink-0 text-gray-500"></ng-icon>
        @if (!hideText()) {
          <span>{{ { key: 'onlyOnOrder' } | i18n }}</span>
        }
      } @else {
        @if (stock.isAvailable) {
          <ng-icon name="heroCheck" size="20px" class="h-5 w-5 flex-shrink-0 text-green-500"></ng-icon>
          @if (!hideText()) {
            <div class="flex flex-col">
            @if (stock.available && stock.available > 0 && (webShop.observeShowDetailedStock() | async)) {
              <span>
                {{
                  {
                    key: 'pceInStock',
                    values: [stock.available],
                    n: stock.available
                  } | i18n
                }}
              </span>
            } @else {
              <span>{{ { key: 'inStock' } | i18n }}</span>
            }
            @if (stock.asLongAsSupplyLasts) {
              <span class="text-xs text-gray-400">Solange Vorrat</span>
            }
            </div>
          }

          <span> </span>
        } @else {
          <ng-icon name="heroQuestionMarkCircle" size="20px" class="h-5 w-5 flex-shrink-0 text-gray-500"></ng-icon>
          @if (!hideText()) {
            <span>{{ { key: 'notInStock' } | i18n }}</span>
          }
        }
      }
    } @else {
      <ng-icon name="heroQuestionMarkCircle" size="20px" class="h-5 w-5 flex-shrink-0 text-gray-500"></ng-icon>
      @if (!hideText()) {
        <span>{{ { key: 'noStockAvailable' } | i18n }}</span>
      }
    }
  </div>
}
